import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { omit } from 'lodash'

import Button from 'components/UI/Button'
import PropTypes from 'prop-types'
import AuthLogic from 'components/Auth/AuthLogic'
import { AuthContext } from 'components/Auth/Auth'

const AuthLoginButton = ({
    className,
    children,
    trackName,
    email,
    userSourceLabeling,
    loginSuccessTarget,
    preserveChecksum,
    buttonProps,
    isPopupLogin = true,
}) => {
    const auth = useContext(AuthContext)
    const { t } = useTranslation()

    return (
        <AuthLogic>
            {({ login }) => (
                <Button
                    className={className}
                    trackName={trackName || 'login'}
                    {...buttonProps}
                    onClick={() => {
                        buttonProps?.onClick && buttonProps.onClick()

                        login({
                            email,
                            successTarget: loginSuccessTarget || null,
                            userSourceLabeling,
                            preserveChecksum,
                            isPopupLogin,
                        })
                    }}
                    data-testid="login-button"
                    loading={auth.almaLoading}
                    disabled={auth.almaLoading}
                >
                    {children || t('common:signIn')}
                </Button>
            )}
        </AuthLogic>
    )
}

AuthLoginButton.propTypes = {
    trackName: PropTypes.string,
    email: PropTypes.string,
    className: PropTypes.string,
    loginSuccessTarget: PropTypes.string,
    preserveChecksum: PropTypes.bool,
    buttonProps: PropTypes.shape(omit(Button.propTypes, ['trackName'])),
    userSourceLabeling: PropTypes.shape({
        source: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }),
}

export default AuthLoginButton
